var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "ItpRow",
            [
              _c(
                "ItpCol",
                { attrs: { col: "7" } },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "8",
                        name: "name",
                        label: _vm._f("pgettext")("Name", "Company"),
                        labelAlign: _vm.labelAlign,
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "name", required: "", autofocus: "" },
                        model: {
                          value: _vm.item.name,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "name", $$v)
                          },
                          expression: "item.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "code",
                        label: _vm._f("pgettext")("Code", "Company"),
                        labelAlign: _vm.labelAlign,
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "number", required: "" },
                        model: {
                          value: _vm.item.code,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "code", $$v)
                          },
                          expression: "item.code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "5",
                        name: "account_type",
                        label: _vm._f("gettext")("Default"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormCheckbox", {
                        attrs: {
                          name: "is_default",
                          inline: "",
                          readonly: _vm.item.isReadOnly
                        },
                        model: {
                          value: _vm.item.is_default,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "is_default", $$v)
                          },
                          expression: "item.is_default"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.item.role === "partner"
                    ? _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "4",
                            contentColsMd: "8",
                            name: "relation",
                            label: _vm._f("pgettext")("Type", "Company"),
                            labelAlign: _vm.labelAlign,
                            required: ""
                          }
                        },
                        [
                          _c("ItpFormSelect", {
                            attrs: {
                              name: "relation",
                              required: "",
                              options: _vm.companyRelations
                            },
                            model: {
                              value: _vm.item.relation,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "relation", $$v)
                              },
                              expression: "item.relation"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "8",
                        name: "groups",
                        label: _vm._f("pgettext")("Groups", "Company"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormSelect2", {
                        attrs: {
                          name: "groups",
                          multiple: "",
                          options: _vm.companyGroups
                        },
                        model: {
                          value: _vm.item.groups,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "groups", $$v)
                          },
                          expression: "item.groups"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "8",
                        name: "emails",
                        label: _vm._f("pgettext")("Email", "Company"),
                        labelAlign: _vm.labelAlign,
                        description: _vm._f("pgettext")(
                          "Multiple email addresses should be separated by semicolon.",
                          "Company"
                        )
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { type: "text", name: "emails" },
                        model: {
                          value: _vm.item.emails,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "emails", $$v)
                          },
                          expression: "item.emails"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "8",
                        name: "external_key",
                        label: _vm._f("pgettext")("External key", "Company"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "number" },
                        model: {
                          value: _vm.item.external_key,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "external_key", $$v)
                          },
                          expression: "item.external_key"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        contentColsMd: "8",
                        name: "notes",
                        label: _vm._f("pgettext")("Notes", "Company"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormTextarea", {
                        attrs: { name: "notes" },
                        model: {
                          value: _vm.item.notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "notes", $$v)
                          },
                          expression: "item.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpCol",
                { attrs: { col: "5" } },
                [
                  _vm.displayFetchByTaxNumber
                    ? _c(
                        "ItpAlert",
                        {
                          staticClass: "offset-md-4",
                          attrs: { type: "info", show: "" }
                        },
                        [
                          _c("ItpIcon", { attrs: { fa: "info-circle" } }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("pgettext")(
                                    "By providing the tax number, the company data can be directly retrieved from the NAV database.",
                                    "Company"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "tax_number",
                        label: _vm._f("pgettext")("Tax number", "Company"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c(
                        "DIV",
                        [
                          _c("ItpFormInput", {
                            attrs: { name: "tax_number" },
                            model: {
                              value: _vm.item.tax_number,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "tax_number", $$v)
                              },
                              expression: "item.tax_number"
                            }
                          }),
                          _vm._v(" "),
                          _vm.displayFetchByTaxNumber && _vm.item.tax_number
                            ? _c("ItpButton", {
                                staticClass: "mt-3",
                                attrs: {
                                  variant: "primary",
                                  icon: _vm.$config.downloadIcon,
                                  tooltip: _vm._f("pgettext")(
                                    "Fetch taxpayer data from NAV database",
                                    "Company"
                                  ),
                                  disabled: !_vm.item.tax_number,
                                  spinning: _vm.actions.fetchTaxpayer.isRunning,
                                  size: "sm",
                                  text: _vm._f("pgettext")(
                                    "Retrieve data",
                                    "Company"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.evh_8497951412896552_clickPreventStop(
                                      $event,
                                      {}
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "tax_number",
                        label: _vm._f("pgettext")(
                          "Tax number history",
                          "Company"
                        ),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormTextarea", {
                        attrs: { name: "tax_number_history", mode: "list" },
                        model: {
                          value: _vm.item.tax_number_history,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "tax_number_history", $$v)
                          },
                          expression: "item.tax_number_history"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "group_member_tax_number",
                        label: _vm._f("pgettext")(
                          "Group member tax number",
                          "Company"
                        ),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "group_member_tax_number" },
                        model: {
                          value: _vm.item.group_member_tax_number,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "group_member_tax_number", $$v)
                          },
                          expression: "item.group_member_tax_number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "eu_tax_number",
                        label: _vm._f("pgettext")("EU tax number", "Company"),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "eu_tax_number" },
                        model: {
                          value: _vm.item.eu_tax_number,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "eu_tax_number", $$v)
                          },
                          expression: "item.eu_tax_number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        labelColsMd: "4",
                        name: "registration_number",
                        label: _vm._f("pgettext")(
                          "Registration number",
                          "Company"
                        ),
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: { name: "registration_number" },
                        model: {
                          value: _vm.item.registration_number,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "registration_number", $$v)
                          },
                          expression: "item.registration_number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isOwnCompany
                    ? _c(
                        "DIV",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "settings_send_invoice_notifications",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "send_invoice_notifications",
                                  label: _vm._f("pgettext")(
                                    "Send invoice notifications",
                                    "Company"
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.evh_2014513287668498_input(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value:
                                    _vm.settings.send_invoice_notifications,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "send_invoice_notifications",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.send_invoice_notifications"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                contentColsMd: "8",
                                name: "settings_smtp_mail_account_id",
                                labelAlign: _vm.labelAlign,
                                label: _vm._f("pgettext")(
                                  "SMTP Mail Account",
                                  "Company"
                                )
                              }
                            },
                            [
                              _c("UcMailAccountSelector", {
                                attrs: {
                                  name: "smtp_mail_account_id",
                                  item: _vm.settings,
                                  path: "smtp_mail_account_id",
                                  clearable: "",
                                  bindObject: _vm.b_1490259005804208_bindObject
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.evh_1490259005804208_input(
                                      $event,
                                      {}
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isOwnCompany
                    ? _c(
                        "DIV",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "payment_period_days",
                                label: _vm._f("pgettext")(
                                  "Payment period",
                                  "Company"
                                ),
                                labelColsMd: "4",
                                contentColsMd: "5",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group"
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "number",
                                  name: "payment_period_days"
                                },
                                model: {
                                  value: _vm.item.payment_period_days,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "payment_period_days",
                                      $$v
                                    )
                                  },
                                  expression: "item.payment_period_days"
                                }
                              }),
                              _vm._v(" "),
                              _c("DIV", { staticClass: "input-group-append" }, [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("pgettext")(
                                            "days",
                                            "InputGroupAddon"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "discount",
                                label: _vm._f("pgettext")(
                                  "Discount",
                                  "Company"
                                ),
                                labelColsMd: "4",
                                contentColsMd: "4",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group"
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { type: "number", name: "discount" },
                                model: {
                                  value: _vm.item.discount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "discount", $$v)
                                  },
                                  expression: "item.discount"
                                }
                              }),
                              _vm._v(" "),
                              _c("DIV", { staticClass: "input-group-append" }, [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [_vm._v("\n              %\n            ")]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "is_contractor",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "is_contractor",
                                  label: _vm._f("pgettext")(
                                    "Contractor",
                                    "Company"
                                  )
                                },
                                model: {
                                  value: _vm.item.is_contractor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "is_contractor", $$v)
                                  },
                                  expression: "item.is_contractor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "sole_proprietor",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "sole_proprietor",
                                  label: _vm._f("pgettext")(
                                    "Sole proprietor",
                                    "Company"
                                  )
                                },
                                model: {
                                  value: _vm.item.sole_proprietor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "sole_proprietor", $$v)
                                  },
                                  expression: "item.sole_proprietor"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "is_natural_person",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "is_natural_person",
                                  label: _vm._f("pgettext")(
                                    "Natural person",
                                    "Company"
                                  )
                                },
                                model: {
                                  value: _vm.item.is_natural_person,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "is_natural_person", $$v)
                                  },
                                  expression: "item.is_natural_person"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "vat_exempt",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "vat_exempt",
                                  label: _vm._f("pgettext")(
                                    "VAT exempt",
                                    "Company"
                                  )
                                },
                                model: {
                                  value: _vm.item.vat_exempt,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "vat_exempt", $$v)
                                  },
                                  expression: "item.vat_exempt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "excluded_from_claims",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "excluded_from_claims",
                                  label: _vm._f("pgettext")(
                                    "Exclude from claims",
                                    "Company"
                                  )
                                },
                                model: {
                                  value: _vm.item.excluded_from_claims,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "excluded_from_claims",
                                      $$v
                                    )
                                  },
                                  expression: "item.excluded_from_claims"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "settings_notifications_enabled",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "settings__notifications_enabled",
                                  label: _vm._f("pgettext")(
                                    "Notifications enabled",
                                    "Company"
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.evh_5501809153536538_input(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.settings.notifications_enabled,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "notifications_enabled",
                                      $$v
                                    )
                                  },
                                  expression: "settings.notifications_enabled"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                name: "settings_send_invoice_notifications",
                                labelAlign: _vm.labelAlign
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "settings__send_invoice_notifications",
                                  label: _vm._f("pgettext")(
                                    "Send invoice notifications",
                                    "Company"
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.evh_1014170467214631_input(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value:
                                    _vm.settings.send_invoice_notifications,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "send_invoice_notifications",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.send_invoice_notifications"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "4",
                                contentColsMd: "8",
                                name: "settings__email_recipients",
                                label: _vm._f("pgettext")(
                                  "Email recipients",
                                  "Company"
                                ),
                                labelAlign: _vm.labelAlign,
                                description: _vm._f("pgettext")(
                                  "Input one email address per row.",
                                  "Company"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: {
                                  type: "text",
                                  name: "settings__email_recipients",
                                  mode: "list"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.evh_4664876391460503_input(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.settings.email_recipients,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "email_recipients",
                                      $$v
                                    )
                                  },
                                  expression: "settings.email_recipients"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }